import React, { memo, useState } from "react";
import { Controller } from "react-hook-form";
import { PatternFormat } from "react-number-format";
import {
  FormControl,
  FormErrorMessage,
  Input,
  InputGroup,
  InputLeftAddon,
  InputProps,
} from "@chakra-ui/react";

interface IProps extends Omit<InputProps, "value" | "defaultValue" | "type"> {
  control: any;
  name: string;
  error?: any;
}

const PhoneInput = ({ name, control, error, ...rest }: IProps) => {
  const [formattedValue, setFormattedValue] = useState("");

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: "Required",
        minLength: { value: 10, message: "Invalid" },
        maxLength: { value: 10, message: "Invalid" },
      }}
      render={({ field: { onChange } }) => (
        <FormControl isInvalid={!!error}>
          <InputGroup>
            <InputLeftAddon>+1</InputLeftAddon>
            <PatternFormat
              id="phone" // needed for browser autocomplete
              type="tel"
              autoFocus
              format="(###) ###-####"
              value={formattedValue}
              autoComplete="tel-national"
              onValueChange={(values) => {
                setFormattedValue(values.formattedValue);
                onChange(values.value);
              }}
              customInput={Input}
              roundedTopLeft="none"
              roundedBottomLeft="none"
              {...rest}
            />
          </InputGroup>
          <FormErrorMessage justifyContent="flex-end">
            {error?.message}
          </FormErrorMessage>
        </FormControl>
      )}
    />
  );
};

export default memo(PhoneInput);
